import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import ProfileTab from "@/components/ProfileTab";
import HistoryTab from "@/components/HistoryTab";
import BillingTab from "@/components/BillingTab";

export default function UserDashboard({ open, onOpenChange, defaultTab = "profile", onReopenJob, currentDb }) {
  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    if (open) setActiveTab(defaultTab);
  }, [defaultTab, open]);

  const triggerClass =
    "flex-1 h-full rounded-none border-b-2 border-transparent " +
    "data-[state=active]:border-[var(--sdb-accent)] data-[state=active]:text-[var(--sdb-accent)] " +
    "data-[state=inactive]:text-[var(--sdb-text-muted)] " +
    "font-mono text-[10px] tracking-[2px] uppercase bg-transparent shadow-none " +
    "hover:text-[var(--sdb-text)] transition-colors";

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="w-[440px] sm:w-[440px] max-w-full p-0 gap-0 [&>button]:hidden"
        style={{
          background: "var(--sdb-bg)",
          borderLeft: "1px solid var(--sdb-border)",
          color: "var(--sdb-text)",
        }}
      >
        {/* Header */}
        <SheetHeader
          className="px-5 h-14 flex flex-row items-center justify-between border-b space-y-0"
          style={{ background: "var(--sdb-surface)", borderColor: "var(--sdb-border)" }}
        >
          <SheetTitle className="font-mono text-[10px] tracking-[2px] uppercase font-normal" style={{ color: "var(--sdb-text)" }}>
            Account
          </SheetTitle>
          <button
            onClick={() => onOpenChange(false)}
            className="rounded-sm p-1 transition-colors focus:outline-none"
            style={{ color: "var(--sdb-text-muted)" }}
          >
            <X className="h-4 w-4" strokeWidth={1.5} />
            <span className="sr-only">Close</span>
          </button>
        </SheetHeader>

        {/* Tabs */}
        <Tabs
          value={activeTab}
          onValueChange={setActiveTab}
          className="w-full flex flex-col"
          style={{ height: "calc(100vh - 56px)" }}
        >
          <TabsList
            className="w-full flex justify-start rounded-none border-b p-0 h-10 shrink-0"
            style={{ background: "var(--sdb-surface)", borderColor: "var(--sdb-border)" }}
          >
            <TabsTrigger value="profile" className={triggerClass}>Profile</TabsTrigger>
            <TabsTrigger value="history" className={triggerClass}>History</TabsTrigger>
            <TabsTrigger value="billing" className={triggerClass}>Billing</TabsTrigger>
          </TabsList>

          <div className="flex-1 overflow-y-auto p-5">
            <TabsContent value="profile" className="mt-0 outline-none">
              <ProfileTab />
            </TabsContent>
            <TabsContent value="history" className="mt-0 outline-none">
              <HistoryTab onReopenJob={onReopenJob} currentDb={currentDb} />
            </TabsContent>
            <TabsContent value="billing" className="mt-0 outline-none">
              <BillingTab />
            </TabsContent>
          </div>
        </Tabs>
      </SheetContent>
    </Sheet>
  );
}
